import fetcher from "../api/fetacher";

export const gatAllSettings = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher("/setting", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const gatOneSetting = async ({ type }) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher(`/setting/${type}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const getEnabledSettingUsers = async (name) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const params = {};
    if (name) {
      params.name = name;
    }
    const res = await fetcher(
      "/setting/enabled-users",
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
      params,
    );
    return res;
  } catch (error) {
    throw error;
  }
};

const parseStoredValue = (raw) => {
  let parsed = raw;
  for (let i = 0; i < 2 && typeof parsed === "string"; i += 1) {
    try {
      parsed = JSON.parse(parsed);
    } catch (error) {
      return parsed;
    }
  }
  return parsed;
};

export const parseSettingBoolean = (raw) => {
  if (typeof raw === "boolean") return raw;
  if (raw == null || raw === "") return false;

  const text = String(raw).trim();
  if (/^true$/i.test(text)) return true;
  if (/^false$/i.test(text)) return false;

  try {
    return parseSettingBoolean(JSON.parse(text));
  } catch (error) {
    return false;
  }
};

export const parseUserIdList = (raw) => {
  if (raw == null || raw === "") return null;
  const parsed = parseStoredValue(raw);
  return Array.isArray(parsed) ? parsed : null;
};

export const featureEnabledForUser = ({ enabledRaw, userIdsRaw, userId }) => {
  const enabled = parseSettingBoolean(enabledRaw);
  if (!enabled) return false;

  const ids = parseUserIdList(userIdsRaw);
  if (ids == null) return true;
  if (userId == null) return false;

  return ids.some((id) => String(id) === String(userId));
};

export const readFeatureForUser = async (enabledType, usersType, userId) => {
  const enabledRes = await gatOneSetting({ type: enabledType });
  let userIdsRaw = enabledRes?.data?.userIds ?? null;
  if (userIdsRaw == null) {
    try {
      const usersRes = await gatOneSetting({ type: usersType });
      if (usersRes?.code === "00") {
        userIdsRaw = usersRes?.data?.value;
      }
    } catch (error) {
      userIdsRaw = null;
    }
  }

  return featureEnabledForUser({
    enabledRaw: enabledRes?.data?.value,
    userIdsRaw,
    userId,
  });
};

export const updateSetting = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher("/setting/update", {
      method: "POST",
      body: JSON.stringify(data),
      cache: "no-store",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};
